interface SparklineProps {
  values: readonly number[];
  /** Farbe der Linie. Vorgabe ist der erste Ton der Palette. */
  colour?: string;
}

/**
 * Der Verlaufsstrich in einer Kennzahlkachel.
 *
 * **Ohne Achsen, ohne Beschriftung, ohne Werte** -- und deshalb
 * ``aria-hidden``: Er zeigt eine Richtung, keine Zahl. Die Zahl steht
 * daneben in der Kachel, und ein vorlesendes Programm liest sie dort. Ein
 * Strich, den man nicht abmessen kann, als Bild anzukuendigen, waere ein
 * Versprechen, das er nicht haelt.
 */
export function Sparkline({ values, colour }: SparklineProps) {
  if (values.length < 2) return null;

  const ceiling = Math.max(...values, 1);
  const points = values
    .map((value, index) => {
      const x = (index / (values.length - 1)) * 100;
      const y = 24 - (value / ceiling) * 22 - 1;
      return `${String(x)},${String(y)}`;
    })
    .join(' ');

  return (
    <svg
      viewBox="0 0 100 24"
      preserveAspectRatio="none"
      className="chart-sparkline"
      aria-hidden="true"
      focusable="false"
    >
      <polyline
        points={points}
        fill="none"
        stroke={colour ?? 'var(--chart-1)'}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
